export class Name
{
	first = "";
	middle = "";
	last = "";
	suffix = "";
	prefix = "";

	toString() { return `${this.prefix} ${this.first} ${this.middle} ${this.last} ${this.suffix}`; }
}


// WEBPACK FOOTER //
// ./src/models/Name.ts